import { createTheme } from '@mui/material/styles';

const portalTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0f766e',
      dark: '#0b5f59',
      light: '#14b8a6',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#134e4a',
      contrastText: '#ffffff'
    },
    background: {
      default: '#eef3f2',
      paper: '#ffffff'
    },
    text: {
      primary: '#102a27',
      secondary: '#5b6b68'
    },
    success: { main: '#067647' },
    error: { main: '#b42318' },
    warning: { main: '#b54708' },
    divider: '#d7e3e0'
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Segoe UI", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 }
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10, boxShadow: 'none' },
        contained: {
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          border: '1px solid #d7e3e0',
          boxShadow: '0 8px 24px rgba(16, 42, 39, 0.06)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: 'linear-gradient(180deg, #0f766e 0%, #115e59 55%, #134e4a 100%)',
          color: '#fff',
          borderRight: 'none'
        }
      }
    }
  }
});

export default portalTheme;
